// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.floating-window {
  position: fixed;
  top: 0px;
  right: 0px;
  width: 100vw;
  height: 100vh;
  overflow-y: scroll;
  z-index: 3;
  transition: right 1s ease-in-out;
}
.floating-window .floating-overlay {
  position: absolute;
  top: 0px;
  right: 0px;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.65);
  z-index: 2;
}
.floating-window .floating-content {
  width: 98vw;
  height: 100vh;
  overflow-y: scroll;
  position: absolute;
  right: 0px;
  background-color: #FFF;
  z-index: 5;
}
.floating-window .floating-content::-webkit-scrollbar {
  display: none;
}
.floating-window.hide {
  transition: right 1s ease-in-out;
  right: -100vw;
}
.floating-window::-webkit-scrollbar {
  display: none;
}

.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}
.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/App.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EAEA,UAAA;EAEA,gCAAA;AAFF;AAIE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,qCAAA;EAGA,UAAA;AAJJ;AAOE;EACE,WAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,sBAAA;EAEA,UAAA;AANJ;AAQI;EACE,aAAA;AANN;AAUE;EACE,gCAAA;EACA,aAAA;AARJ;AAWE;EACE,aAAA;AATJ;;AAaA;EACE,kBAAA;AAVF;;AAaA;EACE,cAAA;EACA,oBAAA;AAVF;;AAaA;EACE;IACE,4CAAA;EAVF;AACF;AAaA;EACE,yBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;EACA,YAAA;AAXF;;AAcA;EACE,cAAA;AAXF;;AAcA;EACE;IACE,uBAAA;EAXF;EAaA;IACE,yBAAA;EAXF;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');\n\n.floating-window {\n  position: fixed;\n  top: 0px;\n  right: 0px;\n  width: 100vw;\n  height: 100vh;\n  overflow-y: scroll;\n\n  z-index: 3;\n\n  transition: right 1s ease-in-out;\n\n  .floating-overlay {\n    position: absolute;\n    top: 0px;\n    right: 0px;\n    width: 100vw;\n    height: 100vh;\n    background-color: rgba(0,0,0,0.65);\n    // filter: blur(2px);\n\n    z-index: 2;\n  }\n  \n  .floating-content {\n    width: 98vw;\n    height: 100vh;\n    overflow-y: scroll;\n    position: absolute;\n    right: 0px;\n    background-color: #FFF;\n\n    z-index: 5;\n    \n    &::-webkit-scrollbar {\n      display: none;\n    }\n  }\n  \n  &.hide {\n    transition: right 1s ease-in-out;\n    right: -100vw;\n  }\n  \n  &::-webkit-scrollbar {\n    display: none;\n  }\n}\n\n.App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
